import React, { PureComponent } from 'react';
import LoadingIcon from 'appSrc/v5/components/UI/LoadingIcon';
import style from './styles/style.module.css';

export default class LoadingOverlay extends PureComponent {
    render() {
        return (
            <div className={ style.loadingBlockOverlay } style={ this.props.style }>
                <LoadingIcon />
            </div>
        );
    }
}
